export const color = {
  primary: '#008cba', // blue
  success: '#008000', // green
  danger: '#f44336', // red
  alert: '#e5e500', // yellow
  warning: '#F89C1C', // orange
  secondary: '#e7e7e7', // light gray

  textDarkest: '#000',
  textDark: '#333',
  textMedium: '#444',
  textLight: '#fff',
  textLink: '#0052cc',

  borderLightest: '#dfe1e6',
  borderLight: '#c1c7d0',
  borderMedium: '#808080',
  borderInputFocus: '#4c9aff',

  backgroundMedium: '#303030', // sub-heading-bgcolor
  backgroundLight: '#eee',
  backgroundLightest: '#fff',

  backgroundAccentMedium: '#C80005',
  backgroundAccentDark: '#870505',
  backgroundDarkPrimary: '#262626',

  backgroundLightPrimary: '#D2E5FE',
  backgroundLightSuccess: '#E4FCEF',
};

export const font = {
  regular: 'font-family: "RobotoRegular"; font-weight: normal;',
  medium: 'font-family: "RobotoMedium"; font-weight: normal;',
  bold: 'font-family: "RobotoBold"; font-weight: normal;',
  black: 'font-family: "RobotoBlack"; font-weight: normal;',
  size: (size) => `font-size: ${size}em;`,
};
